import React from "react";
import { Button } from "antd";
import { PastOrdersState } from "../../common/types";
const DesktopDescription = ({ item }: PastOrdersState) => {
  return (
    <div style={{ display: "flex", fontSize: 12 }}>
      <div style={{ flex: 1 }}>
        {item.itemName} X{item.quantity}
      </div>

      <div style={{ flex: 1 }}>Total Paid ₹200</div>

      <div
        style={{
          display: "flex",
          flex: 1,
          color: "#8a584b",
          fontWeight: 600,
          justifyContent: "flex-end",
        }}
      >
        <Button className="btn-green">REORDER</Button>
      </div>
    </div>
  );
};

export default DesktopDescription;
